import { SNACKBAR_COLORS } from 'src/components/atoms/Snackbar/constant';
import { type IActiveUploadItem } from '../../epos-upload-store';

export const STATUS_COLOR_MAP: Record<IActiveUploadItem['status'], string> = {
  IN_PROGRESS: SNACKBAR_COLORS.warning,
  FAILED: SNACKBAR_COLORS.error,
  SUCCESS: SNACKBAR_COLORS.success,
};
